/* src/app/reports/rpt-income/rpt-income.component.css */
:host {
  --ins: blue;
  --clm-hd-bkg: oklch(from blue 90% 0.02 h);
  --det-hd-bkg: oklch(79.609% 0.0381 30.301);
  --pay-hd-bkg: oklch(88.003% 0.02931 145.479);
  --vt-cols: 10ch 8ch 4ch 15ch repeat(5, 10ch) 8ch 2.5ch 3ch 1ch;
  --vt-heads-det: 11ch 4.5ch 9ch 5ch 6ch repeat(3, 9ch) 12.5ch 20ch;
  --vt-cols-det: 10ch 4ch 8ch 6ch 4ch repeat(3, 8ch) 12ch 20ch;
  --vt-heads-pay: 10ch 10ch 11ch 22ch 9.5ch 20ch 20ch;
  --vt-cols-pay: 9ch 9ch 10ch 20ch 8.25ch 18ch 18ch;
  --vt-header-h: 32px;
  --claim-bg: oklab(96.77799999999999% -0.0034 -0.01508);
  --claim-hover: oklab(94.594% -0.0049 -0.02547);
  --claim-accent: oklab(90% -0.0034 -0.01508);
  --det-bg: oklab(98.042% 0.00557 0.01126);
  --det-hover: oklab(96.07900000000001% 0.01088 0.02397);
  --det-accent: oklab(93% 0.00557 0.01126);
  --pay-bg: oklab(96.59% -0.01392 0.00948);
  --pay-hover: oklab(94.586% -0.02095 0.01436);
  --pay-accent: oklab(91% -0.01392 0.00948);
}
.vt-row--clm-hover {
  background: var(--claim-hover);
  transition: background .12s;
}
.vt-row--det-hover {
  background: var(--det-hover);
  transition: background .12s;
}
.vt-row--pay-hover {
  background: var(--pay-hover);
  transition: background .12s;
}
table {
  table-layout: fixed;
  width: 100%;
}
.mat-table-wrapper {
  overflow-x: auto;
}
.font9 {
  font-size: .5625rem;
}
.font10 {
  font-size: .625rem;
}
.font11 {
  font-size: .6875rem;
}
.font12 {
  font-size: .75rem;
}
.font13 {
  font-size: .8125rem;
}
.font14 {
  font-size: .875rem;
}
.font15 {
  font-size: .9375rem;
}
.rtalign {
  text-align: right;
}
.rtalign-hdr {
  display: flex;
  justify-content: flex-end;
}
.footer-totals-panel {
  display: flex;
  background-color: hsl(51, 40%, 70%);
  font-weight: bold;
}
.footer-col {
  flex: 1;
  padding: 0 1rem;
  display: flex;
  align-items: center;
}
.footer-col:first-child {
  justify-content: flex-start;
}
.footer-col:nth-child(2) {
  justify-content: center;
}
.footer-col:nth-child(3) {
  justify-content: center;
}
.footer-col:nth-child(4) {
  justify-content: center;
}
.footer-col:nth-child(5) {
  justify-content: center;
}
.footer-col:last-child {
  justify-content: flex-end;
}
.ins-header-row {
  background-color: var(--n-80);
  height: 1.5rem;
}
.ins-odd-row {
  background-color: var(--n-95);
  height: 1rem;
  cursor: pointer;
}
.ins-even-row {
  background-color: var(--n-99);
  height: 1rem;
  cursor: pointer;
}
.ins-footer {
  background-color: var(--n-80);
  font-weight: bold;
  height: 1.5rem;
}
.clm-header-row {
  background-color: var(--clm-hd-bkg);
  height: 1.3rem;
}
.det-header-row {
  background-color: var(--det-hd-bkg);
  height: 1.3rem;
  cursor: default;
}
.det-row:nth-child(odd) {
  background-color: var(--n-95);
  height: 1rem;
  cursor: default;
}
.det-row:nth-child(even) {
  background-color: var(--n-99);
  height: 1rem;
  cursor: default;
}
.pay-header-row {
  background-color: var(--pay-hd-bkg);
  height: 1.3rem;
  cursor: unset;
}
.pay-row:nth-child(odd) {
  background-color: var(--n-95);
  cursor: unset;
}
.pay-row:nth-child(even) {
  background-color: var(--n-99);
  cursor: unset;
}
.pay-row {
  height: 1rem;
}
.link-button {
  background: none;
  border: none;
  padding: 0;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
.link-button:hover {
  text-decoration: none;
}
.link-button:focus {
  outline: none;
}
.toolbar-sm {
  height: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: clamp(0.25rem, 2vw, 1.5rem);
}
.vh500 {
  height: 500px;
  display: block;
}
.expanded-row {
  padding: 0;
}
.vt {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
}
.vt-sticky {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fafafa;
}
.vt-row--odd {
  background: #bcdcf8;
}
.vt-shell {
  position: relative;
}
.vt-header {
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--claim-accent);
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
  white-space: nowrap;
}
.vt-viewport {
  height: 50vh;
  overflow: auto;
  scrollbar-gutter: stable;
  padding-top: var(--vt-header-h);
}
.vt-grid {
  display: grid;
  grid-template-columns: var(--vt-cols);
  column-gap: .5rem;
}
.vt-grid-det-heads {
  display: grid;
  grid-template-columns: var(--vt-heads-det);
  column-gap: .5rem;
  padding-left: 2rem;
  font-weight: 600;
  background: var(--det-accent);
}
.vt-grid-pay-heads {
  display: grid;
  grid-template-columns: var(--vt-heads-pay);
  column-gap: .5rem;
  padding-left: 2rem;
  font-weight: 600;
  background: var(--pay-accent);
}
.vt-grid-det-cols {
  display: grid;
  grid-template-columns: var(--vt-cols-det);
  column-gap: .5rem;
  padding-left: 2rem;
}
.vt-grid-pay-cols {
  display: grid;
  grid-template-columns: var(--vt-cols-pay);
  column-gap: .5rem;
  padding-left: 2rem;
}
.vt-row {
  height: 32px;
  box-sizing: content-box;
  align-items: center;
  border-bottom: 1px solid #ced9f0;
}
.vt-row-det,
.vt-row-pay {
  height: 20px;
  box-sizing: content-box;
  align-items: center;
  border-bottom: 1px solid #ced9f0;
}
.vt-row--clm-bg {
  background: var(--claim-bg);
}
.vt-row--det-bg {
  background: var(--det-bg);
}
.vt-row--pay-bg {
  background: var(--pay-bg);
}
.vt-row--odd {
  background: #f9fafb;
}
.vt-cell--num {
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.vt-cell--center {
  text-align: center;
  white-space: nowrap;
}
.vt-cell--right {
  text-align: right;
  white-space: nowrap;
}
.vt-cell--truncate {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vt-cell--truncate-start {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  direction: rtl;
  text-align: left;
}
.vt-cell--truncate-start > span {
  direction: ltr;
  unicode-bidi: plaintext;
}
.chk {
  width: 13px;
  height: 13px;
  border: 1px solid #999;
  border-radius: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: .85em;
  background: #fff;
}
.chk--on::after {
  content: "\2713";
  line-height: 1;
}
/*# sourceMappingURL=rpt-income.component.css.map */
